import { render, staticRenderFns } from "./eventsList.vue?vue&type=template&id=5ba3df80&"
import script from "./eventsList.vue?vue&type=script&lang=js&"
export * from "./eventsList.vue?vue&type=script&lang=js&"
import style0 from "./eventsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports